/* eslint-disable react/prop-types */
import React from 'react';
import styles from './styles.module.scss';

/**
 * Flag component
 * @param {object} props - Component props
 * @param {string} props.text - Flag text
 */
export const Flag = ({ text }) => (
  <div className={styles.flag}>
    {text}
  </div>
);
